/* eslint-disable no-param-reassign */
xplenty.directive('bigQuerySourceEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./big-query-source-editor.html'),

      replace: true,

      link(scope) {
        scope.isLegacySQLDisabled = false;
        scope.isStoredProcedureDisabled = false;

        if (scope.component.stored_procedure) {
          scope.isLegacySQLDisabled = true;
          scope.component.use_legacy_sql = false;
        }

        if (scope.component.use_legacy_sql) {
          scope.isStoredProcedureDisabled = true;
          scope.component.stored_procedure = false;
        }

        scope.$watch('component.use_legacy_sql', (value) => {
          if (value) {
            scope.isStoredProcedureDisabled = true;
            scope.component.stored_procedure = false;
          } else {
            scope.isStoredProcedureDisabled = false;
          }
        });

        scope.$watch('component.stored_procedure', (value) => {
          if (value) {
            scope.isLegacySQLDisabled = true;
            scope.component.use_legacy_sql = false;
          } else {
            scope.isLegacySQLDisabled = false;
          }
        });
      },
    };
  },
]);
